import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { SortDirection } from "react-virtualized";
import moment from "moment";

import Paper from "@material-ui/core/Paper";
import RadioCheckedIcon from "material-ui/svg-icons/toggle/check-box";
import RadioIcon from "material-ui/svg-icons/toggle/check-box-outline-blank";
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from '@material-ui/core/CircularProgress';

import WrappedVirtualizedTable from "./Table";
import ImagesPopup from "./ImagesPopup";
import IssueCreator from "./IssueCreator";
import IssuesView from "./IssuesView";

import * as issueSelectors from "../../redux/issues/selectors";
import * as authSelectors from "../../redux/auth/selectors";
import * as projectSelectors from '../../redux/projects/selectors'

import { getUserProjects, getProject } from '../../redux/projects/actions';
import {
  getIssuesByProjectIdListener,
  createPost,
  editPost,
  deletePost,
  createReport,
  subscribeToIssuesByIds,
  clearIssues
} from "../../redux/issues/actions";
import { getProjectLocations } from '../../redux/locations/actions';

import {
  setProjectId
} from "../../redux/checklists/actions";

import sorting from "./sorting";
import { prepareLocation, getIssueStatus } from "../../utils/issues";
import {
  categoriesOriginal,
  heCategoriesOriginal
} from "../../fixtures/categories";

import "./Issue.css";
import * as checklistSelectors from "../../redux/checklists/selectors";
import {get} from "lodash";

function prepareIssueTitle(issue, delimiter = '\n') {
  const name = [];
  if (issue.checklistItemName) {
    name.push(issue.checklistItemName);
  }
  if (issue.title) {
    name.push(issue.title);
  }

  return name.join(delimiter);
}


const CATEGORIES_LIST_LOCAL =
  navigator.language.includes('he') ? heCategoriesOriginal : categoriesOriginal;

const ISSUE_LIMIT_FOR_REPORT = 300;

class Issues extends React.Component {
  state = {
    sort: {
      field: 'issueNumber',
      direction: 'desc' // asc desc
    },
    addEditIssue: null,
    reportMode: false,
    issuesForReport: [],
    showPopup: false
  };

  componentDidMount() {
    const { projectsList, selectedProjectId } = this.props;
    const { userId } = JSON.parse(localStorage.getItem("auth0")) || "";

    if (projectsList && Object.keys(projectsList).length && !selectedProjectId) {
      const firstProjectId = Object.values(projectsList)[0].id;

      const { setProjectId } = this.props;
      setProjectId(firstProjectId);
    }

    setProjectId(selectedProjectId);
    this.props.getIssuesByProjectIdListener(selectedProjectId);
    this.props.getUserProjects(userId);
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (nextProps.selectedProjectId !== this.props.selectedProjectId) {
      // const { userId } = JSON.parse(localStorage.getItem("auth0")) || "";

      this.props.getIssuesByProjectIdListener(nextProps.selectedProjectId);
      this.props.getProject(nextProps.selectedProjectId);
      this.props.getProjectLocations(nextProps.selectedProjectId);
    }

    if (Object.keys(nextProps.projectsList).length !== Object.keys(this.props.projectsList).length) {
      const firstProjectId = Object.values(nextProps.projectsList)[0].id;

      const { setProjectId } = this.props;
      setProjectId(firstProjectId);
    }
  }

  fetchIssues = (hits) => {
    const { selectedProjectId } = this.props;

    this.props.subscribeToIssuesByIds({ projectId: selectedProjectId, hits });
  };

  clearIssues = () => {
    const {selectedProjectId} = this.props;

    this.props.clearIssues({projectId: selectedProjectId});
  };

  filteredAvailableIssues = () => {
    const { issues, userId } = this.props;
    const arrIssues = Object.values(issues || {});
    return arrIssues.filter(
      ({ tagged, assignTo, owner, isIssue }) =>
        ((tagged && tagged.hasOwnProperty(userId)) ||
          (assignTo && assignTo.id === userId) ||
          (!tagged || Object.keys(tagged).length === 0) ||
          (owner && owner.id === userId)) &&
        isIssue
    );
    return [];
  };

  notHaveValue = value =>
    value || (
      <div
        style={{
          fontSize: 20,
          fontWeight: "bold",
          // textAlign: "center",
          width: "100%"
        }}
      >{`-`}</div>
    );

  _prepareImageLink = data => {
    if (!data) return [];
    const { selectedProjectId } = this.props;

    let d = { ...data };

    const hasFile = d.hasOwnProperty("file");
    if (hasFile) {
      d = { [data.file.id]: data.file };
    }
    const list = Object.values(d || {});
    if (list.length === 0) return [];

    return list.map(({ id, uri, filestackId, type }) => {
      return { id, projectId: selectedProjectId, uri, isFile: type && type === 'document', filestackId };
    });
  };

  activeSort = field => {
    const { sort } = this.state;
    if (!field) return;
    const getField = () => {
      if (sort.direction === SortDirection.DESC && field.sortBy === sort.field)
        return { field: null, direction: null };
      if (sort.field === field.sortBy) {
        return { field: field.sortBy, direction: SortDirection.DESC };
      } else {
        return { field: field.sortBy, direction: SortDirection.ASC };
      }
    };

    this.setState({ sort: { ...getField() } });
  };

  getIssueStatusElem = status => (
    <div className={`issue-${status ? status.toLowerCase() : ""}`}>
      {status}
    </div>
  );

  limitDescription = text => {
    const SIZE = 100;
    let str = text;
    if (text && text.length > SIZE) {
      str = str.substring(0, SIZE) + "...";
    }
    return str ? <div title={text}>{str}</div> : "";
  };

  clearIssue = () => this.setState({ addEditIssue: null });

  onAdd = post => {
    const { userProfile, createPost, selectedProjectId, project } = this.props;

    createPost(selectedProjectId, post, {}, userProfile, false, project);
  };

  onEdit = post => {
    const { editPost, project, selectedProjectId } = this.props;

    editPost(selectedProjectId, post, project);
  };

  onDelete = post => {
    const { selectedProjectId } = this.props;
    const { deletePost } = this.props;
      deletePost(post, selectedProjectId)
  };

  initiateReportMode = (format) => {
    this.setState({ reportMode: true, reportFormat: format })
  };

  handleRowClick = ({ rowData }) => {
    if (this.state.reportMode) {
      const { issuesForReport } = this.state;
      const cpSelectedIssues =  [...issuesForReport ];

      const { id } = rowData;

      const index = cpSelectedIssues.indexOf(id);

      if (index > -1) {
        cpSelectedIssues.splice(index, 1)
      } else {
        cpSelectedIssues.push(id);
      }

      this.setState({issuesForReport: cpSelectedIssues});

      return;
    }

    this.setState({addEditIssue: rowData})

  };

  togglePopup() {
    this.setState({ showPopup: !this.state.showPopup });
  }

  handleSelectAll = () => {
    const { reportMode, sort, issuesForReport } = this.state;

    if (reportMode) {
      const filteredIssues = Object.values(this.props.issues); //this.filteredAvailableIssues();
      const sortedIssues = sorting[sort.field](filteredIssues, sort.direction)
      // reports is limited up to 300 issues
      const issuesToReport = sortedIssues.length > ISSUE_LIMIT_FOR_REPORT ? sortedIssues.slice(0, ISSUE_LIMIT_FOR_REPORT) : sortedIssues;
      const issuesId = issuesToReport.map((issue) => issue = issue.id);

      const saveIssues = [...issuesForReport, ...issuesId].filter((v, i, a) => a.indexOf(v) === i);

      this.setState({issuesForReport: saveIssues});
      this.togglePopup();
    }
  }

  handleDeselectAll = () => {
    const { issuesForReport } = this.state;

    const issues = [...issuesForReport];

    const arr = Object.values(this.props.issues).map(i => i.id);

    arr.forEach(a => {
      const index = issues.indexOf(a);
      issues.splice(index, 1);
    })


    this.setState({issuesForReport: issues});
  }

  handleCancelReport = () => {
    this.setState({issuesForReport: [], reportMode: false})
  };

  handleCreateReport = async () => {
    const { issuesForReport, reportFormat } = this.state;
    const { createReport, selectedProjectId } = this.props;
    const { userId } = JSON.parse(localStorage.getItem("auth0")) || "";

    if (issuesForReport.length > 0) {
      await createReport({projectId: selectedProjectId, userId, issueIds: issuesForReport, reportFormat});

      this.handleCancelReport();
    }
  };

  renderReportButtons = () => {
    const { reportMode, issuesForReport } = this.state;
    const { pdfLoading } = this.props;


    if (!reportMode) {
      return null;
    }


    if (pdfLoading) {
      return (
        <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: 10}}>
          <CircularProgress size={20} style={{marginRight: 5}}/>
          <span style={{marginRight: 15}}>Preparing report...</span>
        </div>
      )
    }

    let createReportText = 'Create Report';

    if (issuesForReport.length) {
      createReportText = `Create Report (${issuesForReport.length} selected)`
    }

    return (
      <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: 10}}>
        <FlatButton
          label="Cancel"
          onClick={this.handleCancelReport}
          labelStyle={{ color: "#fff" }}
          hoverColor={"rgba(0, 0, 0, 0.54)"}
          backgroundColor={"rgba(0, 0, 0, 0.44)"}
          style={{marginRight: 5}}
        />
        <FlatButton
          label={createReportText}
          onClick={this.handleCreateReport}
          labelStyle={{ color: "#fff" }}
          hoverColor={"#77c723"}
          backgroundColor={"#6da92e"}
          style={{marginRight: 15}}
        />
      </div>
    )
  };


  selectAllCheckBox = () => {
    const { issuesForReport, reportMode } = this.state;
    if (reportMode) {
      const arr = Object.values(this.props.issues).map(i => i.id);

      let x = arr.map(i => issuesForReport.includes(i))
      if (x.includes(true)) {
        return <RadioCheckedIcon onClick={() => this.handleDeselectAll()} style={{color: '#ffff'}} />;
      }
    }

    if (reportMode) {
      return <RadioIcon onClick={() => this.handleSelectAll()} style={{color: '#ffff'}}  /> ;
    }
  }


  render() {
    const { sort, addEditIssue, issuesForReport, reportMode } = this.state;
    const { project, history, selectedProjectId } = this.props;
    let arrIssues = this.filteredAvailableIssues();
    if (sort.field) {
      arrIssues = sorting[sort.field](arrIssues, sort.direction);
    }

    const popup = () => {
      const { showPopup } = this.state;

      if (reportMode && showPopup && arrIssues.length > ISSUE_LIMIT_FOR_REPORT) {
        return (
            <div style={{textAlign: 'right', paddingRight: '1rem' }}><h3>Is limited up to 300 issues in one report</h3></div>
          );
        }
    }

    return (
      <div style={{ position: "relative", marginTop: "90px", marginLeft: "90px" }}>
        <IssueCreator
          issue={addEditIssue}
          onClose={this.clearIssue}
          onAdd={this.onAdd}
          onEdit={this.onEdit}
          onDelete={this.onDelete}
          members={ project ? project.members : {}}
          initiateReportMode={this.initiateReportMode}
          history={history}
          locations={this.props.locations}
        />
        <IssuesView
            issues={this.props.issues}
            fetchIssues={this.fetchIssues}
            clearIssues={this.clearIssues}
            selectedProjectId={selectedProjectId}
            onRowClick={this.handleRowClick}
            reportMode={reportMode}
            issuesForReport={this.state.issuesForReport}
            selectAllCheckBox={this.selectAllCheckBox}
            renderReportButtons={this.renderReportButtons}
        />
        {popup()}
        {/*{this.renderReportButtons()}*/}
      </div>
    );
  }
}

export default connect(
  state => ({
    issues: issueSelectors.issuesList(state),
    selectedProjectId: checklistSelectors.checklistProjectId(state),
    userId: authSelectors.getUserId(state),
    accessToken: authSelectors.getAccessToken(state),
    userProfile: authSelectors.getUserProfile(state),
    projectsList: projectSelectors.projectsList(state),
    project: projectSelectors.projectDetails(state),
    locations: projectSelectors.location(state),
    pdfLoading: issueSelectors.pdfLoading(state)
  }),
  { getIssuesByProjectIdListener, createPost, editPost, deletePost, getUserProjects, getProject, setProjectId, createReport, subscribeToIssuesByIds, clearIssues, getProjectLocations }
)(withRouter(Issues));
